module.exports = __webpack_public_path__ + "static/tech6.09d49d7a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/carousel/technika/tech6.jpg
// module id = 696
// module chunks = 39862026607597